export const config = {
  stripeApiPublicKey: window.__NGINX_CONFIG__.stripeApiPublicKey || 'asdggggggg'
};